import { FC, ReactElement, SyntheticEvent } from 'react';
import { Box, BoxProps, Flex, Image, Text, Skeleton, theme } from '@chakra-ui/react';
import { CbButton } from '../Buttons/CbButton';
import chest from '../../assets/images/chest-card.png';
import raffleTicket from '../../assets/images/raffle-ticket.png';
import chestBackground from '../../assets/images/chest-card-bg.png';
export interface CbChestsCardProps extends BoxProps {
  backgroundColor?: string;
  descriptionElement?: ReactElement;
  isMobile?: boolean;
  isPending?: boolean;
  isOpeningPrize?: boolean;
  isRaffleTicket: boolean;
  canBeOpened: boolean;
  title?: string;
  topRightElement?: ReactElement | null;
  subtitle?: string;
  onButtonClick?: (event: SyntheticEvent) => void;
}
export const CbChestsCard: FC<CbChestsCardProps> = ({
  backgroundColor = 'chonky.500',
  descriptionElement,
  isMobile,
  isOpeningPrize = false,
  isPending,
  isRaffleTicket,
  canBeOpened,
  title = 'Buy a chest',
  topRightElement,
  subtitle,
  onButtonClick,
  ...props
}) => {
  const buttonText = isRaffleTicket ? 'Check Ticket' : 'Open Chest';
  const skeleton = <>
      <Box data-testid="skeleton" position="relative">
        <Box paddingBottom="80%" paddingTop={6} />
        <Skeleton paddingTop={8} position="absolute" top="0" left="0" height="100%" width="100%" zIndex={theme.zIndices.docked} />
      </Box>
      <Box padding={6} marginBottom={6}>
        <Skeleton height={5} maxWidth={24} />
        <Skeleton height={5} marginTop={6} />
        <Skeleton height={5} maxWidth="75%" marginTop={2} />
      </Box>
    </>;
  return <Box boxShadow="standardCard" borderRadius={24} overflow="hidden" {...props} data-sentry-element="Box" data-sentry-component="CbChestsCard" data-sentry-source-file="CbChestsCard.tsx">
      {isPending ? skeleton : <>
          <Box backgroundColor={backgroundColor} padding={6} position="relative">
            <Box position="absolute" top="50%" left="50%" transform="translate(-42%, -55%)" width="140%">
              <Image src={chestBackground} width="100%" height="auto" />
            </Box>
            <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -40%)" width="90%">
              {isRaffleTicket ? <Image src={raffleTicket} width="72%" margin="0 auto" height="auto" /> : <Image src={chest} width="100%" height="auto" />}
            </Box>
            <Flex justifyContent="space-between" zIndex={theme.zIndices.docked}>
              <Text color="white" fontFamily="codenext">
                {title}
              </Text>
              {topRightElement}
            </Flex>
            <Box paddingBottom="78%" />
          </Box>
          <Box backgroundColor="white" paddingTop={5} paddingBottom={6} paddingX={6}>
            {subtitle && <Text color="text.tertiary" fontSize="sm" fontWeight="semibold" marginBottom={4}>
                {subtitle}
              </Text>}
            {descriptionElement}
            <Box>
              <CbButton onClick={onButtonClick} width="100%" isLoading={isOpeningPrize} disabled={!canBeOpened || isOpeningPrize}>
                {buttonText}
              </CbButton>
            </Box>
          </Box>
        </>}
    </Box>;
};